import { anyApi } from "convex/server";

// Convex replaces these dynamic references with generated, schema-specific types
// after `bunx convex dev`. Keeping this boundary local avoids coupling the Vite
// composite project to backend implementation modules.
export const api = anyApi;
